<template>
  <div class="login-page">
    <div class="login-bg" />
    <div class="content text-center">
      <div class="ibox">
        <div class="ibox-title">
          <img
            src="../../assets/images/imea-logo-color.svg"
            alt
            class="logo-login"
          />
        </div>
        <div class="ibox-content">
          <form @submit.prevent="submit()">
            <p>{{ $t('login.type_credentials') }}</p>
            <div class="form-group" :class="{ 'has-error': error }">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-user" />
                </span>
                <input
                  v-model="username"
                  type="text"
                  class="form-control"
                  name="usuario"
                  :placeholder="$t('login.username')"
                />
              </div>
            </div>
            <div class="form-group" :class="{ 'has-error': error }">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-lock" />
                </span>
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  name="senha"
                  :placeholder="$t('login.password')"
                />
              </div>
            </div>
            <p class="text-danger">{{ error }}</p>
            <button type="submit" class="btn btn-primary btn-block">
              {{ $t('login.login_btn') }}
            </button>
            <router-link
              :to="{ name: 'registro-create' }"
              class="btn btn-white btn-block m-b"
            >
              {{ $t('login.register') }}
            </router-link>
            <a class="link-password" :href="link">{{ $t('login.forgot') }}</a>
            <hr />
            <div style="margin-bottom: 10px">
              <a class="link-password" @click="changeLang('pt-BR')">PT</a> |
              <a class="link-password" @click="changeLang('en')">EN</a>
            </div>
            <div>
              <a
                target="_blank"
                href="http://imea.com.br/imea-site/termo-de-uso.html"
              >
                {{ $t('login.terms') }}
              </a>
              |
              <a
                target="_blank"
                href="http://imea.com.br/imea-site/politica.html"
                >{{ $t('login.privacy') }}</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <footer class="footer-login">
      <div class="footer-content">
        <span>{{ $t('developed_by') }}</span>
        <a href="http://www.sydy.com.br" target="blank">
          <img src="../../assets/images/logo-sydy.svg" alt class="logo-sydy" />
        </a>
      </div>
    </footer>
    <div v-if="loading">
      <div class="overlay" />
      <i class="fa fa-circle-o-notch fa-spin loader" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import base from '../../store/base'
import hideLoading from '../../lib/hideLoading'

export default {
  name: 'Login',
  methods: {
    changeLang(lang) {
      localStorage.setItem('locale', lang)
      location.reload()
    },
    submit() {
      this.loading = true
      this.$validator
        .validateScopes()
        .then(() => {
          const username = this.username
          const password = this.password
          this.login({ username, password, grant_type: 'password' })
            .then(() => {
              // this.$router.push({ name: 'home' })
              this.$router.push({ name: 'instituicao' })
              this.$analytics.logEvent('login')
            })
            .catch(err => {
              this.loading = false
              const { response } = err
              if (response) {
                this.error = response.data.error_description
              } else {
                this.error =
                  'Ocorreu um erro inesperado. Tente novamente, se o erro persistir entre em contato com os administradores.'
              }
            })
        })
        .catch(() => {})
    },
    ...mapActions('login', ['login'])
  },
  created() {
    this.link = base.slice(0, -4)
    document.title = 'Login - IMEA'
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')
    this.$analytics.setUserProperties({
      UserName: '',
      InstituicaoName: ''
    })
  },
  mounted() {
    hideLoading()
  },
  data() {
    return {
      username: '',
      password: '',
      link: '',
      loading: false,
      error: null
    }
  }
}
</script>
